import { render, staticRenderFns } from "./TeamMemberDef.vue?vue&type=template&id=4ea4bfda&scoped=true&"
import script from "./TeamMemberDef.vue?vue&type=script&lang=js&"
export * from "./TeamMemberDef.vue?vue&type=script&lang=js&"
import style0 from "./TeamMemberDef.vue?vue&type=style&index=0&id=4ea4bfda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea4bfda",
  null
  
)

export default component.exports